import '../ManageLessons.scss';
import { Editor } from 'react-draft-wysiwyg';
import { ContentState, EditorState } from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import { useState } from 'react';
import { convertContent, modifyPastedText } from 'utilities/textEditorHelper';

type Props = {
  lessonContent: string;
  handleLessonContent: (lessonContent: string) => void;
};

export const TextLessonField = ({ lessonContent, handleLessonContent }: Props) => {
  const [editorState, setEditorState] = useState(() => {
    if (!lessonContent) {
      return EditorState.createEmpty();
    } else {
      const contentBlock = htmlToDraft(lessonContent);

      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
        const editorState = EditorState.createWithContent(contentState);
        return editorState;
      }
    }
  });

  const handlePastedText = (text: string, html: string | undefined, state: EditorState): boolean => {
    const newContent = modifyPastedText(text, html, state);
    setEditorState(EditorState.push(state, newContent, 'insert-fragment'));
    return true;
  };

  const saveContent = () => {
    const cleanedContent = convertContent(editorState);
    handleLessonContent(cleanedContent);
  };

  return (
    <Editor
      editorState={editorState}
      toolbarClassName='text-editor-toolbar'
      wrapperClassName='text-editor-wrapper'
      editorClassName='text-editor'
      onEditorStateChange={(editorState) => setEditorState(editorState)}
      handlePastedText={handlePastedText}
      onChange={saveContent}
    />
  );
};
